<nav class="header__links flex flex-row items-center">
  @if (location === 'student') {
    <span class="mat-body-2" i18n>Welcome {{ user.firstName }}!</span>
  } @else {
    <a
      mat-button
      routerLink="/features"
      routerLinkActive="active"
      [routerLinkActiveOptions]="{ exact: true }"
      i18n
      >Features</a
    >
    <a
      mat-button
      routerLink="/about"
      routerLinkActive="active"
      [routerLinkActiveOptions]="{ exact: true }"
      i18n
      >About Us</a
    >
    <a mat-button routerLink="/curriculum" routerLinkActive="active" i18n>Curriculum</a>
    <a mat-button href="https://wise-discuss.berkeley.edu" i18n>Community</a>
    <a mat-button href="https://wise-research.berkeley.edu" i18n>Research</a>
  }
  @if (roles.length === 0) {
    <app-header-signin />
  }
</nav>
